import { render, staticRenderFns } from "./TableDelivery.vue?vue&type=template&id=db5490cc&scoped=true&"
import script from "./TableDelivery.vue?vue&type=script&lang=ts&"
export * from "./TableDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./TableDelivery.vue?vue&type=style&index=0&id=db5490cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5490cc",
  null
  
)

export default component.exports